import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const CaretIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.30568 8.30568C4.50167 8.10994 4.76733 8 5.04432 8C5.32131 8 5.58697 8.10994 5.78295 8.30568L12.0126 14.5353L18.2422 8.30568C18.4403 8.12105 18.7024 8.02054 18.9732 8.02532C19.244 8.03009 19.5024 8.13979 19.6939 8.3313C19.8854 8.5228 19.9951 8.78116 19.9998 9.05195C20.0046 9.32274 19.9041 9.58481 19.7195 9.78295L12.7512 16.7512C12.5552 16.9469 12.2896 17.0569 12.0126 17.0569C11.7356 17.0569 11.4699 16.9469 11.2739 16.7512L4.30568 9.78295C4.10994 9.58697 4 9.32131 4 9.04432C4 8.76733 4.10994 8.50167 4.30568 8.30568Z"
        fill={fillStyle || '#000000'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default CaretIcon
